import { Component } from 'react';
import { deleteLinkedAccount } from './query';
import Loading from '../../components/Loading';

class DeleteLinkedUser extends Component {
    constructor() {
        super();

        this.deleteAccount = this.deleteAccount.bind(this);

        this.state = {
            loading: false,
        };
    }

    async deleteAccount() {
        try {
            const { account_id, user_email } = this.props;
            this.setState({ loading: true });
            await deleteLinkedAccount(account_id, user_email);
            window.location.reload();
        } catch (err) {
            console.log(err);
        }
    }

    render() {
        return (
            <div>
                {this.state.loading ? (
                    <Loading onlyPreloader />
                ) : (
                    <button
                        onClick={this.deleteAccount}
                        className="settings-action-btn"
                        title="Delete Account"
                    >
                        <i className="icon-delete"></i>
                    </button>
                )}
            </div>
        );
    }
}

export default DeleteLinkedUser;
